// src/com/trans_plan_return/TransPlanReturnGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN_RETURN Apollo Graphql
 * 센터반납 정보
 * Project: NewTOP for cloud
 * 2024-12-27 15:48:44 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const TRANS_PLAN_RETURN_FIELDS = gql`
fragment TransPlanReturnListPart on TransPlanReturn {
    planId
    dcReturnKpp
    dcReturnAju
    dcReturnRollcage
    dcReturnSpt
    dcReturnNjc800
    dcReturnDanpra
    dcReturnEtc
    dcReturnNote
    dcReturnSpt533
    dcReturnFull
    dcReturnHalf
    dcReturnSealNo
    dcReturnSealNo2
    dcReturnSealNo3
    dcReturnWooden
    dcReturnOctagon
    dcReturnStackKpp
    dcReturnStackAju
    returnDriverCheckYn
    returnDriverCheckDate
    returnStoreCheckYn
    returnStoreCheckDate
    returnDcCheckYn
    returnDcCheckDate
    returnDcCheckUser
    collectorDate
    collectorSignature
    dcCoverStores
    dcCoverStore1
    dcCoverItem1
    dcCoverStore2
    dcCoverItem2
    dcCoverStore3
    dcCoverItem3
    dcNoReturnCode
    dcNoReturnNote
    dcNoReturnDate
    dcNoReturnUser
    regUser
    regDate
    dcCd
    storeId
    comId
    inputDptrTime
    inputArrTime
    inputTempF
    inputTempM
    inputTempR
    dcName
    storeName
    comName
    regUserName
}
`;


export const GET_TRANS_PLAN_RETURN = gql`
${TRANS_PLAN_RETURN_FIELDS}
query GetTransPlanReturn($planId:String!) {
    transPlanReturnItem(planId:$planId) {
        ...TransPlanReturnListPart
    }
}
`;

/*

extend type Mutation {
	transPlanReturnSave(transPlanReturn: InputTransPlanReturnSave!): CommonResponse!
	transPlanReturnSetNoReturn(transPlanReturn: InputTransPlanReturnSetNoReturn!): CommonResponse!
}
*/

export const SAVE_TRANS_PLAN_RETURN = gql`
mutation SaveTransPlanReturn($transPlanReturn: InputTransPlanReturnSave!) {
    transPlanReturnSave(transPlanReturn:$transPlanReturn) {
        ok
        message
        detail
    }
}
`;

// parameter: {planId, dcNoReturnCode, dcNoReturnNote}
export const SET_TRANS_PLAN_RETURN_NO_RETURN = gql`
mutation SetTransPlanReturnNoReturn($transPlanReturn: InputTransPlanReturnSetNoReturn!) {
    transPlanReturnSetNoReturn(transPlanReturn:$transPlanReturn) {
        ok
        message
    }
}
`;

// transPlanReturnSetDcCheck(transPlanReturn: InputTransPlanReturnSetDcCheck!): CommonResponse!
export const SET_TRANS_PLAN_RETURN_DC_CHECK = gql`
mutation SetTransPlanReturnDcCheck($transPlanReturn: InputTransPlanReturnSetDcCheck!) {
    transPlanReturnSetDcCheck(transPlanReturn:$transPlanReturn) {
        ok
        message
    }
}
`;

